import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'dialog-user-input',
  templateUrl: './dialog-user-input.component.html',
  styleUrls: ['./dialog-user-input.component.css']
})
export class UserInputDialogComponent {
  constructor(public dialogRef: MatDialogRef<UserInputDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: UserInputDialogData) { }

  onClickCancel(): void {
    this.dialogRef.close();
  }
}

export interface UserInputDialogData {
  dialogTitle: string;
  dialogMode: string;
  name: string;
  descriptionText: string;
}
